import React from "react";
import ListMod from "../../../Component/Redesign/ListMod";
import {AutocompleteInput, Datagrid, Filter, FunctionField, ReferenceInput, SelectField, SelectInput, TextField } from "react-admin";
import {convertedDateWithTime} from "../../../Functions/ConvertedDate";
import {RatingSources} from "../../../Const/Enums";

const Filters = () => (
    <Filter>
        <SelectInput label="Rating" source="rating" name="rating" choices={RatingSources} alwaysOn />
    </Filter>
);

export const AiQuestionRatingList = () => {

    return <div className="customTableWrap">
        <ListMod title={'Recent User Feedback'} actions={false} filters={<Filters />} >
            <Datagrid bulkActionButtons={false}>
                <TextField label='Id' source="id" sortBy="id"/>
                <TextField label='Question' source="question" sortBy="question"/>
                <SelectField label="Rating" source="rating" sortBy="rating" choices={RatingSources}/>
                <FunctionField label="Time" source="created_at" sortBy="created_at" render={(record) => {
                    if (!record.created_at) return <></>;
                    return (convertedDateWithTime(record.created_at));
                }}/>
            </Datagrid>
        </ListMod>
    </div>
}